import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { DropdownCard, type IDropdownItem, Status } from 'shared/ui'
import { LINK_SEARCH_SMART_VIEWS } from 'shared/constants/links'
import { useEntitiesContext } from 'entities/EntitiesExport'
import styles from './styles.module.scss'

type ICreateSmartViewActionDropdownItemProps = {
  onClick: () => void
}

const item: IDropdownItem = {
  id: 'create_smart_view',
  iconL: 'filter',
  label: 'Create smart view',
  labelContent: (
    <div className={styles.wrap}>
      Create smart view
      <Status title={'New'} intent={'purple'} emphasis={'high'} size={'label'} />
    </div>
  ),
  ariaLabel: 'createSmartViewButtonSelector',
  iconQuestionProps: {
    fontSize: 14,
  },
  tooltipQuestionProps: {
    placement: 'right',
    label: (
      <>
        Save filters to quickly access
        <br />
        matching conversations in real time.
        <br />
        <a href={`${LINK_SEARCH_SMART_VIEWS}`} target='_blank' rel='noreferrer'>
          Learn more
        </a>
      </>
    ),
  },
}

export const CreateSmartViewActionDropdownItem: FC<ICreateSmartViewActionDropdownItemProps> =
  observer(({ onClick }) => {
    const entities = useEntitiesContext()

    if (!entities.featureFlagsStore.smart_views) return null

    return <DropdownCard item={item} onChange={onClick} />
  })
